import { Card, Statistic, Typography } from 'antd';

const { Text } = Typography;

export interface AIKpiCardProps {
  label: string;
  value: number | string;
  format?: 'number' | 'currency' | 'text';
  formatCurrency?: (n: number) => string;
  hint?: string;
  loading?: boolean;
}

export function AIKpiCard({ label, value, format, formatCurrency, hint, loading }: AIKpiCardProps) {
  const display =
    format === 'currency' && typeof value === 'number' && formatCurrency
      ? formatCurrency(value)
      : value;

  return (
    <Card size="small" loading={loading} className="ai-kpi-card" styles={{ body: { padding: 16 } }}>
      <Statistic title={label} value={display as number} formatter={format === 'currency' ? () => display : undefined} />
      {hint ? (
        <Text type="secondary" style={{ fontSize: 11, marginTop: 4, display: 'block' }}>
          {hint}
        </Text>
      ) : null}
    </Card>
  );
}
